import React, { useState } from "react";
import { ORIGINAL_LANGUAGE_SIGNIFIER } from "components/shared/TranslationDropDown";
import LanguageListItem from "components/shared/LanguageListItem";

export function useTranslationUI() {
  const [selectedLanguage, setSelectedLanguage] = useState(
    ORIGINAL_LANGUAGE_SIGNIFIER,
  );

  const renderLanguageListItem = (
    lang: { language: string; name: string },
    handleClick: (
      event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
      language: string,
    ) => void,
  ) => {
    return (
      <LanguageListItem
        lang={lang}
        selectedLanguage={selectedLanguage}
        handleClick={handleClick}
        setSelectedLanguage={setSelectedLanguage}
      />
    );
  };

  return {
    renderLanguageListItem,
  };
}
